
const NutricodeProtocol = {
  "month": {"variant_id": 54831358968099, "selling_plan_id": "8590754083" },
  "2-month": {"variant_id": 54831359000867, "selling_plan_id": "8590786851" },
  "3-month": {"variant_id": 54831359033635, "selling_plan_id": "8590819619" },
};

const StartingProtocol = {
    "fitness":   {"variant_id": 54836371489059 },
    "strength":  {"variant_id": 54836371521827 },
    "endurance": {"variant_id": 54836371554595 },
    "fatloss":   {"variant_id": 54836371587363 },
    "recovery":  {"variant_id": 54836371620131 },
    "sleep":     {"variant_id": 54836371652899 },
    "longevity": {"variant_id": 54836371685667 },
    "energy":    {"variant_id": 54836371718435 }
  };

const priceProtocolConverted = {
  "month": {
    SGD: 89,
    AUD: 99,
    MYR: 279,
    IDR: 1199000,
    HKD: 549,
    DEFAULT: 89
  },
  "2-month": {
    SGD: 79,
    AUD: 89,
    MYR: 245,
    IDR: 1099000,
    HKD: 489,
    DEFAULT: 79
  },
  "3-month": {
    SGD: 69,
    AUD: 79,
    MYR: 215,
    IDR: 999000,
    HKD: 439,
    DEFAULT: 69
  }
}

/**
 * Which discount tier is live site-wide. Only one is active at a time.
 * Values: 'lowest' | 'medium' | 'highest'
 * Use `var` (not const) so it is also on window — cart sync reads this.
 */
var ACTIVE_PROTOCOL_DISCOUNT_TIER = 'medium';
window.ACTIVE_PROTOCOL_DISCOUNT_TIER = ACTIVE_PROTOCOL_DISCOUNT_TIER;

/** Maps ACTIVE_PROTOCOL_DISCOUNT_TIER → price / variant dictionary keys. */
var PROTOCOL_DISCOUNT_TIER_KEYS = {
  lowest: 'discountLowest',
  medium: 'discountMedium',
  highest: 'discountHighest'
};
window.PROTOCOL_DISCOUNT_TIER_KEYS = PROTOCOL_DISCOUNT_TIER_KEYS;

/**
 * Protocol stack display prices by currency.
 * - base: full / one-time price
 * - discountLowest / discountMedium / discountHighest: subscription prices
 *   for each tier (null = fall back to offer % until filled)
 */
var priceProtocolStackConverted = {
  SGD: {
    base: 139,
    discountLowest: 105,
    discountMedium: 111,
    discountHighest: 119
  },
  AUD: {
    base: 149,
    discountLowest: 112,
    discountMedium: 119,
    discountHighest: 127
  },
  MYR: {
    base: 499,
    discountLowest: 375,
    discountMedium: 399,
    discountHighest: 425
  },
  IDR: {
    base: 1999000,
    discountLowest: 1499000,
    discountMedium: 1599000,
    discountHighest: 1699000
  },
  HKD: {
    base: 999,
    discountLowest: 749,
    discountMedium: 799,
    discountHighest: 849
  },
  NZD: {
    base: 179,
    discountLowest: 135,
    discountMedium: 143,
    discountHighest: 152
  },
  DEFAULT: {
    base: 139,
    discountLowest: 105,
    discountMedium: 111,
    discountHighest: 119
  }
};
window.priceProtocolStackConverted = priceProtocolStackConverted;

/**
 * Shopify variant (+ selling plan) per stack price tier.
 * Variant IDs are global; markets own the currency price on the variant.
 * - base → one-time / full-price — NEVER attach a selling plan
 * - discount* → subscription variants for ACTIVE_PROTOCOL_DISCOUNT_TIER
 */
var protocolStackVariants = {
  base: { variant_id: 54831358968099, selling_plan_id: null },
  discountLowest: { variant_id: 55350994403619, selling_plan_id: 8590754083 },
  discountMedium: { variant_id: 55350994305315, selling_plan_id: 8590754083 },
  discountHighest: { variant_id: 55254343876899, selling_plan_id: 8590754083 }
};
window.protocolStackVariants = protocolStackVariants;

/**
 * Save-label copy for each discount tier (shown next to "Ongoing Plan").
 * Keys match ACTIVE_PROTOCOL_DISCOUNT_TIER: lowest | medium | highest
 */
var protocolDiscountTierSaveText = {
  lowest: 'Save 25%',
  medium: 'Save 20%',
  highest: 'Save 15%'
};
window.protocolDiscountTierSaveText = protocolDiscountTierSaveText;

/** Active tier's save label, e.g. "Save 25%". Empty string if unset. */
function getActiveProtocolDiscountSaveText() {
  var map =
    (typeof window !== 'undefined' && window.protocolDiscountTierSaveText) ||
    (typeof protocolDiscountTierSaveText !== 'undefined' ? protocolDiscountTierSaveText : null);
  if (!map) return '';
  var tier =
    typeof getActiveProtocolDiscountTier === 'function'
      ? getActiveProtocolDiscountTier()
      : String(
          (typeof window !== 'undefined' && window.ACTIVE_PROTOCOL_DISCOUNT_TIER) ||
            'medium'
        ).toLowerCase();
  var text = map[tier];
  return text == null || text === '' ? '' : String(text);
}
window.getActiveProtocolDiscountSaveText = getActiveProtocolDiscountSaveText;

/**
 * Source of truth for the live discount tier.
 * Always re-reads window.ACTIVE_PROTOCOL_DISCOUNT_TIER (kept in sync with the var above).
 */
function getActiveProtocolDiscountTier() {
  var raw =
    (typeof window !== 'undefined' && window.ACTIVE_PROTOCOL_DISCOUNT_TIER != null
      ? window.ACTIVE_PROTOCOL_DISCOUNT_TIER
      : typeof ACTIVE_PROTOCOL_DISCOUNT_TIER !== 'undefined'
        ? ACTIVE_PROTOCOL_DISCOUNT_TIER
        : 'medium');
  var tier = String(raw || 'medium').toLowerCase().trim();
  if (tier === 'lowest' || tier === 'medium' || tier === 'highest') return tier;
  return 'medium';
}

/** Update the live tier at runtime and optionally re-sync the plan cart. */
function setActiveProtocolDiscountTier(tier, options) {
  var next = String(tier || '').toLowerCase().trim();
  if (next !== 'lowest' && next !== 'medium' && next !== 'highest') {
    console.warn('setActiveProtocolDiscountTier: invalid tier', tier);
    return getActiveProtocolDiscountTier();
  }
  ACTIVE_PROTOCOL_DISCOUNT_TIER = next;
  window.ACTIVE_PROTOCOL_DISCOUNT_TIER = next;
  var shouldSync = !options || options.syncCart !== false;
  if (shouldSync && typeof window.syncPlanPageCart === 'function') {
    Promise.resolve(window.syncPlanPageCart()).catch(function (err) {
      console.warn('setActiveProtocolDiscountTier: cart sync failed', err);
    });
  }
  return next;
}
window.getActiveProtocolDiscountTier = getActiveProtocolDiscountTier;
window.setActiveProtocolDiscountTier = setActiveProtocolDiscountTier;

function getActiveProtocolDiscountPriceKey() {
  var map =
    (typeof window !== 'undefined' && window.PROTOCOL_DISCOUNT_TIER_KEYS) ||
    (typeof PROTOCOL_DISCOUNT_TIER_KEYS !== 'undefined' ? PROTOCOL_DISCOUNT_TIER_KEYS : null);
  if (!map) return 'discountMedium';
  return map[getActiveProtocolDiscountTier()] || 'discountMedium';
}

function getProtocolStackEntry(currencyCode) {
  var cc = String(currencyCode || '').toUpperCase();
  var map =
    (typeof window !== 'undefined' && window.priceProtocolStackConverted) ||
    (typeof priceProtocolStackConverted !== 'undefined' ? priceProtocolStackConverted : null);
  if (!map) return null;
  return map[cc] || map.DEFAULT || null;
}

function getProtocolStackVariantEntry(tierKey) {
  var map =
    (typeof window !== 'undefined' && window.protocolStackVariants) ||
    (typeof protocolStackVariants !== 'undefined' ? protocolStackVariants : null);
  if (!map || !tierKey) return null;
  return map[tierKey] || null;
}

/** Active discount tier's variant entry (discountLowest / Medium / Highest). */
function getActiveProtocolDiscountVariantEntry() {
  return getProtocolStackVariantEntry(getActiveProtocolDiscountPriceKey());
}

/** Full / one-time protocol stack price for a currency. */
function getProtocolStackBase(currencyCode) {
  var entry = getProtocolStackEntry(currencyCode);
  return entry ? (Number(entry.base) || 0) : 0;
}

/**
 * Ongoing / discounted protocol stack price for the active tier + currency.
 * Returns null when not set yet (callers should fall back to offer %).
 */
function getProtocolStackDiscountPrice(currencyCode) {
  var entry = getProtocolStackEntry(currencyCode);
  if (!entry) return null;
  var key = getActiveProtocolDiscountPriceKey();
  if (entry[key] == null || entry[key] === '') return null;
  var n = Number(entry[key]);
  return isNaN(n) ? null : n;
}

/** Savings amount (base − active discount price). Null when discount unset. */
function getProtocolStackDiscountAmount(currencyCode) {
  var discounted = getProtocolStackDiscountPrice(currencyCode);
  if (discounted == null) return null;
  return Math.max(0, getProtocolStackBase(currencyCode) - discounted);
}

/** All configured protocol-stack variant ids (base + discount tiers). */
function getProtocolStackVariantIdSet() {
  var ids = [];
  var map =
    (typeof window !== 'undefined' && window.protocolStackVariants) ||
    (typeof protocolStackVariants !== 'undefined' ? protocolStackVariants : null);
  if (!map) return ids;
  Object.keys(map).forEach(function (key) {
    var entry = map[key];
    if (entry && entry.variant_id != null && entry.variant_id !== '') {
      ids.push(String(entry.variant_id));
    }
  });
  return ids;
}

window.getActiveProtocolDiscountVariantEntry = getActiveProtocolDiscountVariantEntry;
window.getActiveProtocolDiscountPriceKey = getActiveProtocolDiscountPriceKey;
window.getProtocolStackVariantEntry = getProtocolStackVariantEntry;
window.getProtocolStackEntry = getProtocolStackEntry;
window.getProtocolStackBase = getProtocolStackBase;
window.getProtocolStackDiscountPrice = getProtocolStackDiscountPrice;
window.getProtocolStackDiscountAmount = getProtocolStackDiscountAmount;
window.getProtocolStackVariantIdSet = getProtocolStackVariantIdSet;




  /* ══════════════════════════════════════════════════════════════════
     DICTIONARIES (converted from TS)
     ══════════════════════════════════════════════════════════════════ */

  var GOAL_ORDER = ['fitness', 'strength', 'endurance', 'fatloss', 'recovery', 'sleep', 'longevity', 'energy'];

  var goalDisplayData = {
    fitness:   { title: 'General Fitness',       subtitle: 'Build all-round fitness' },
    strength:  { title: 'Strength & Power',      subtitle: 'Get stronger and more explosive' },
    endurance: { title: 'Endurance & VO2',       subtitle: 'Boost stamina and aerobic capacity' },
    fatloss:   { title: 'Fat Loss & Metabolism',  subtitle: 'Burn fat more efficiently' },
    recovery:  { title: 'Recovery & Repair',     subtitle: 'Recover faster and repair better' },
    sleep:     { title: 'Sleep & Circadian',     subtitle: 'Sleep deeper and more consistently' },
    longevity: { title: 'Longevity & Aging',     subtitle: 'Support long-term healthspan' },
    energy:    { title: 'Energy & Cognition',    subtitle: 'Sharpen focus and daily energy' }
  };

  var goalImages = {
    fitness:   'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fitness.webp?v=1773465078',
    strength:  'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/strength.webp?v=1773465078',
    endurance: 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/endurance.webp?v=1773465079',
    fatloss:   'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/fatloss.webp?v=1773465078',
    recovery:  'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/recovery.webp?v=1773465078',
    sleep:     'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/sleep.webp?v=1773465078',
    longevity: 'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/longevity.webp?v=1773465079',
    energy:    'https://cdn.shopify.com/s/files/1/0781/4522/4995/files/energy.webp?v=1773465079'
  };

  var goalPopupDescriptions = {
    fitness:   'Improves how efficiently your body produces and uses energy across both training and daily life. Helps you build a stronger fitness base, better endurance, and more consistent performance.',
    strength:  'Supports the muscle and nervous system processes that drive force, explosiveness, and physical output. Helps you lift stronger, move faster, and perform with more power.',
    endurance: 'Supports oxygen use, mitochondrial function, and your ability to sustain effort for longer. Helps you improve stamina, aerobic capacity, and overall endurance performance.',
    fatloss:   'Supports the systems involved in energy burn, appetite regulation, and metabolic efficiency. Helps you burn fat more effectively while maintaining better energy and recovery.',
    recovery:  'Supports the repair processes that help your body recover after training, stress, and physical strain. Helps you bounce back faster, reduce fatigue, and stay more consistent.',
    sleep:     'Supports the pathways involved in relaxation, sleep depth, and circadian rhythm balance. Helps you fall asleep more easily, sleep more deeply, and wake up more restored.',
    longevity: 'Supports the core systems linked to long-term resilience, healthy function, and physical vitality over time. Helps you maintain better energy, recovery, and health as you age.',
    energy:    'Supports the brain and cellular energy processes that drive focus, clarity, and mental stamina. Helps you feel sharper, think more clearly, and sustain energy throughout the day.'
  };

  var goalMetricDescriptions = {
    fitness:   { 'VO2 Max': 'Aerobic fitness capacity', '1RM': 'Maximum strength output', 'RHR': 'Cardiovascular efficiency marker' },
    strength:  { '1RM': 'Peak strength capacity', 'Power': 'Explosive force production', 'HRV': 'Recovery readiness signal' },
    endurance: { 'VO2 Max': 'Endurance engine size', 'Training Intensity': 'Sustainable work capacity', 'RHR': 'Aerobic adaptation marker' },
    fatloss:   { 'BMR': 'Resting calorie burn', 'RHR': 'Metabolic health signal', 'Sleep Quality': 'Hormonal regulation support' },
    recovery:  { 'HRV': 'Recovery status indicator', 'RHR': 'System stress marker', 'Sleep Quality': 'Repair process quality' },
    sleep:     { 'Deep & REM': 'Restorative sleep stages', 'Sleep Latency': 'Sleep onset speed', 'Sleep Disruptions': 'Nighttime stability marker' },
    longevity: { 'VO2 Max': 'Longevity fitness predictor', 'RHR': 'Heart health marker', 'Sleep Quality': 'Healthy aging foundation' },
    energy:    { 'HRV': 'Nervous system balance', 'Sleep Quality': 'Cognitive recovery quality', 'VO2 Max': 'Energy production capacity' }
  };

  var supplementMechanisms = {
    fitness:   { 'Ashwagandha': 'Supports both strength output and aerobic performance, making it one of the best broad-spectrum ingredients for improving overall training capacity.', 'Magnesium': 'Supports muscle function, recovery, and sleep quality, helping improve consistency across fitness metrics like RHR, 1RM, and VO2 Max.', 'Omega-3 (EPA/DHA)': 'Supports cardiovascular health, recovery, and autonomic balance, making it relevant for broad improvements in training readiness and resting markers.', 'Vitamin D3': 'Supports muscle function and physical performance, especially in people who are low to begin with.' },
    strength:  { 'Ashwagandha': 'Has some of the best evidence in your stack for improving strength, force output, and training adaptations.', 'Magnesium': 'Supports muscle contraction, neuromuscular efficiency, and recovery between hard sessions.', 'Vitamin D3': 'Supports strength and power output, especially when correcting low vitamin D status.', 'Zinc': 'Helps maintain normal hormone function, immune resilience, and recovery under heavy training stress.' },
    endurance: { 'Iron': 'Directly affects oxygen transport and aerobic capacity, especially when iron levels are low.', 'Ashwagandha': 'Has evidence for improving cardiorespiratory fitness and VO2-related outcomes, making it useful beyond just strength.', 'CoQ10': 'Supports mitochondrial energy production, making it a logical fit for endurance performance and sustained output.', 'Omega-3 (EPA/DHA)': 'Supports cardiovascular function, recovery, and training tolerance across repeated sessions.' },
    fatloss:   { 'Ashwagandha': 'Helps regulate stress response, which can support better recovery, better training quality, and better control over stress-driven eating.', 'Magnesium': 'Supports sleep quality and metabolic regulation, both of which are closely linked to body composition.', 'Omega-3 (EPA/DHA)': 'Supports cardiometabolic health and recovery, making it useful in a body-composition-focused protocol even if it is not a direct fat burner.', 'Probiotics': 'Supports gut health, which can influence appetite regulation, inflammation, and metabolic health.' },
    recovery:  { 'Omega-3 (EPA/DHA)': 'Supports the body\'s inflammatory response and recovery after training stress.', 'Magnesium': 'Supports muscle relaxation, recovery quality, and sleep, all of which are key parts of repair.', 'CoQ10': 'Supports cellular energy production and may help reduce exercise-related fatigue and oxidative stress.', 'Probiotics': 'Supports gut health, immune balance, inflammation control, and sleep quality, all of which influence recovery.' },
    sleep:     { 'Magnesium': 'Supports relaxation, sleep quality, and the body\'s ability to settle into deeper rest.', 'Ashwagandha': 'Helps lower stress load, which can make it easier to fall asleep and improve overall sleep quality.', 'Zinc': 'Plays a role in sleep regulation and recovery, making it a useful support ingredient in a sleep-focused stack.', 'Probiotics': 'Supports the gut-sleep connection, which can help improve sleep quality and nighttime recovery.' },
    longevity: { 'Omega-3 (EPA/DHA)': 'Supports cardiovascular health and healthy aging, making it a strong foundation for a longevity-focused protocol.', 'CoQ10': 'Supports mitochondrial function and cellular energy, both of which are central to healthy aging.', 'Vitamin D3': 'Supports musculoskeletal health, immune function, and overall physical resilience with age.', 'Magnesium': 'Supports sleep, recovery, metabolic health, and neuromuscular function, all of which matter for long-term healthspan.' },
    energy:    { 'Vitamin B12': 'Supports energy production and cognitive function, especially in people with low intake or poor absorption.', 'CoQ10': 'Supports mitochondrial energy production, making it relevant for both physical and mental energy.', 'Magnesium': 'Supports nervous system function, stress regulation, and sleep quality, all of which influence energy and cognition.', 'Omega-3 (EPA/DHA)': 'Supports brain health, cognitive function, and overall recovery, making it a strong fit for this protocol.' }
  };

  /* Expose dictionaries globally for other sections */
  window.ncGoalDisplayData = goalDisplayData;
  window.ncGoalImages = goalImages;
  window.ncGoalPopupDescriptions = goalPopupDescriptions;
  window.ncGoalMetricDescriptions = goalMetricDescriptions;
  window.ncSupplementMechanisms = supplementMechanisms;


   /* ══════════════════════════════════════════════════════════════════
     SUPPLEMENT NAME MAPPING
     Maps names used in supplementMechanisms → keys in global dicts
     (pills_floating, pillCounts, doses, unit)
     ══════════════════════════════════════════════════════════════════ */
  var suppNameMap = {
    'Ashwagandha': 'Ashwagandha',
    'Magnesium': 'Magnesium',
    'Omega-3 (EPA/DHA)': 'Omega 3',
    'Vitamin D3': 'Vitamin D',
    'Zinc': 'Zinc',
    'Iron': 'Iron',
    'CoQ10': 'CoQ10',
    'Probiotics': 'Probiotics',
    'Vitamin B12': 'Vitamin B12'
  };
  window.suppNameMap = suppNameMap;

  var suppFallbackInfo = {
    'Ashwagandha': { pillCount: '2 capsules', dose: 900, unit: 'mg' },
    'Magnesium':   { pillCount: '2 tablets',  dose: 400, unit: 'mg' },
    'Omega 3':     { pillCount: '3 softgels', dose: 1920, unit: 'mg' },
    'Vitamin D':   { pillCount: '1 softgel',  dose: 125, unit: 'mcg' },
    'Zinc':        { pillCount: '1 tablet',   dose: 50,  unit: 'mg' },
    'Iron':        { pillCount: '1 tablet',   dose: 65,  unit: 'mg' },
    'CoQ10':       { pillCount: '1 capsule',  dose: 200, unit: 'mg' },
    'Probiotics':  { pillCount: '1 capsule',  dose: 136, unit: 'mg' },
    'Vitamin B12': { pillCount: '1 tablet',   dose: 1000, unit: 'mcg' }
  };
  window.suppFallbackInfo = suppFallbackInfo;

  /* ══════════════════════════════════════════════════════════════════
     EXPECTED OUTCOMES (per goal)
     ══════════════════════════════════════════════════════════════════ */
var goalExpectedOutcomes = {
    fitness: [
      { metric: 'VO2 Max', desc: 'Aerobic fitness capacity',           value: '+10%',    direction: 'up' },
      { metric: '1RM',     desc: 'Maximum strength output',            value: '+14%',   direction: 'up' },
      { metric: 'RHR',     desc: 'Cardiovascular efficiency marker',   value: '\u22124 BPM', direction: 'down' }
    ],
    strength: [
      { metric: '1RM',   desc: 'Peak strength capacity',       value: '+14%',  direction: 'up' },
      { metric: 'Power', desc: 'Explosive force production',   value: '+9%',  direction: 'up' },
      { metric: 'HRV',   desc: 'Recovery readiness signal',    value: '+18%',  direction: 'up' }
    ],
    endurance: [
      { metric: 'VO2 Max',            desc: 'Endurance engine size',        value: '+10%',        direction: 'up' },
      { metric: 'Training Intensity', desc: 'Sustainable work capacity',    value: '+14%',        direction: 'up' },
      { metric: 'RHR',                desc: 'Aerobic adaptation marker',    value: '\u22124 BPM', direction: 'down' }
    ],
    fatloss: [
      { metric: 'BMR',           desc: 'Resting calorie burn',           value: '+8%',         direction: 'up' },
      { metric: 'RHR',           desc: 'Metabolic health signal',        value: '\u22124 BPM', direction: 'down' },
      { metric: 'Sleep Quality', desc: 'Hormonal regulation support',    value: '+15%',        direction: 'up' }
    ],
    recovery: [
      { metric: 'HRV',           desc: 'Recovery status indicator', value: '+18%',        direction: 'up' },
      { metric: 'RHR',           desc: 'System stress marker',      value: '\u22124 BPM', direction: 'down' },
      { metric: 'Sleep Quality', desc: 'Repair process quality',    value: '+15%',        direction: 'up' }
    ],
    sleep: [
      { metric: 'Deep & REM',        desc: 'Restorative sleep stages',    value: '+20%',  direction: 'up' },
      { metric: 'Sleep Latency',     desc: 'Sleep onset speed',           value: '\u221235%', direction: 'down' },
      { metric: 'Sleep Disruptions', desc: 'Nighttime stability marker',  value: '\u221240%', direction: 'down' }
    ],
    longevity: [
      { metric: 'VO2 Max',      desc: 'Longevity fitness predictor', value: '+10%',         direction: 'up' },
      { metric: 'RHR',          desc: 'Heart health marker',         value: '\u22124 BPM', direction: 'down' },
      { metric: 'Sleep Quality', desc: 'Healthy aging foundation',   value: '+15%',        direction: 'up' }
    ],
    energy: [
      { metric: 'HRV',           desc: 'Nervous system balance',        value: '+18%', direction: 'up' },
      { metric: 'Sleep Quality', desc: 'Cognitive recovery quality',    value: '+15%', direction: 'up' },
      { metric: 'VO2 Max',      desc: 'Energy production capacity',    value: '+10%',  direction: 'up' }
    ]
  };
  window.goalExpectedOutcomes = goalExpectedOutcomes;
  
/* ══════════════════════════════════════════════════════════════════
RESEARCH ARTICLES (per goal → per supplement → articles)
══════════════════════════════════════════════════════════════════ */
var goalResearchArticles = {
  fitness: {
    'Ashwagandha': [
      { title: 'Ashwagandha Standardized Root Extract Improves Physical Endurance and VO2max in Healthy Adults Performing Resistance Training.', meta: 'Ziegenfuss et al. (2024). \u00b7 F1000Research', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11234080/' },
      { title: 'Examining the Effect of Withania somnifera Supplementation on Muscle Strength and Recovery', meta: 'Wankhede et al. (2015) \u00b7 Journal of the International Society of Sports Nutrition', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC4658772/' },
      { title: 'Ashwagandha Root Extract Improves Cardiorespiratory Endurance and Recovery in Healthy Athletic Adults', meta: 'Shenoy et al. (2021) \u00b7 Journal of Ethnopharmacology', link: 'https://pubmed.ncbi.nlm.nih.gov/33600918/' }
    ],
    'Magnesium': [
      { title: 'Effects of Magnesium Supplementation on Muscle Soreness and Performance', meta: 'Reno et al. (2022) \u00b7 Journal of Strength and Conditioning Research', link: 'https://pubmed.ncbi.nlm.nih.gov/33009349/' },
    ],
    'Omega-3 (EPA/DHA)': [
      { title: 'DHA-Rich Fish Oil Increases the Omega-3 Index in Healthy Adults and Slows Resting Heart Rate without Altering Cardiac Autonomic Reflex Modulation', meta: 'Macartney et al. (2021) \u00b7 Journal of the American College of Nutrition', link: 'https://pubmed.ncbi.nlm.nih.gov/34379997/' },
      { title: 'Omega-3 Fatty Acid Supplementation on Post-Exercise Inflammation, Muscle Damage, Oxidative Response, and Sports Performance in Physically Healthy Adults — A Systematic Review of Randomized Controlled Trials.', meta: 'Tinsley et al. (2024) \u00b7 Nutrients / PMC', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11243702/' }
    ],
    'Vitamin D3': [
      { title: 'The Effect of Vitamin D Supplementation on Muscle Damage After Eccentric Exercise in Young Men: A Randomized Controlled Trial.', meta: 'Pilch et al. (2020) \u00b7 Journal of the International Society of Sports Nutrition', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC7661179/' },
      { title: 'Vitamin D3 Supplementation (5,000 IU/day) on Immune Response, Aerobic Capacity, and Muscle Damage in Healthy Adults Performing Strenuous Endurance Exercise.', meta: 'Chang et al. (2023) \u00b7 Nutrients', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC10215688/' }
    ]
  },
  strength: {
    'Ashwagandha': [
      { title: 'Examining the Effect of Withania somnifera Supplementation on Muscle Strength and Recovery: A Randomized Controlled Trial.', meta: 'Wankhede et al. (2015) \u00b7 Journal of the International Society of Sports Nutrition', link: 'https://pubmed.ncbi.nlm.nih.gov/26609282/' },
      { title: 'Ashwagandha Standardized Root Extract on Physical Endurance and VO2max in Healthy Adults Performing Resistance Training', meta: 'Ziegenfuss et al. (2024) \u00b7 Journal of the International Society of Sports Nutrition', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11234080/' },
    ],
    'Magnesium': [
      { title: 'Effect of Magnesium Supplementation on Strength Training in Humans.', meta: 'Brilla & Haley (1992) \u00b7 Journal of the American College of Nutrition', link: 'https://pubmed.ncbi.nlm.nih.gov/1619184/' },
      { title: 'Long-Term HRV Analysis Shows Stress Reduction by Magnesium Intake.', meta: 'Wienecke & Nolden (2016) \u00b7 MMW – Fortschritte der Medizin', link: 'https://pubmed.ncbi.nlm.nih.gov/27933574/' }
    ],
    'Vitamin D3': [
      { title: 'Assessment of Vitamin D Concentration in Non-Supplemented Professional Athletes and Healthy Adults: Implications for Skeletal Muscle Function.', meta: 'Close et al. (2013) \u00b7 Journal of Sports Sciences', link: 'https://pubmed.ncbi.nlm.nih.gov/23083379/' },
      { title: 'Vitamin D and Exercise Performance in Professional Soccer Players', meta: 'Koundourakis et al. (2014) \u00b7 PLOS ONE', link: 'https://pubmed.ncbi.nlm.nih.gov/24992690/' }
    ],
    'Zinc': [
      { title: 'Correlation Between Serum Zinc and Testosterone: A Systematic Review.', meta: 'Te et al. (2023) \u00b7 Journal of Trace Elements in Medicine and Biology', link: 'https://pubmed.ncbi.nlm.nih.gov/36577241/' },
      { title: 'The Effects of Zinc Supplementation and Weight Training on Testosterone Levels.', meta: 'Talaghir et al. (2017) \u00b7 Gymnasium Journal', link: 'https://www.researchgate.net/publication/322364874_The_effects_of_the_zinc_supplementation_and_weight_trainings_on_the_testosterone_levels' },
      { title: 'Zinc Status and Serum Testosterone Levels of Healthy Adults.', meta: 'Prasad et al. (1996) \u00b7 Nutrition', link: 'https://pubmed.ncbi.nlm.nih.gov/8875519/' }
    ]
  },
  endurance: {
    'Iron': [
      { title: 'Effects of Oral Iron Supplementation on Blood Iron Status in Athletes: A Systematic Review, Meta-Analysis and Meta-Regression of Randomized Controlled Trials.', meta: 'Díaz-Leal et al. (2024) \u00b7 Sports Medicine', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11127818/' }
    ],
    'Ashwagandha': [
      { title: 'Ashwagandha Standardized Root Extract on Physical Endurance and VO2max in Healthy Adults Performing Resistance Training.', meta: 'Ziegenfuss et al. (2024) \u00b7 Journal of the International Society of Sports Nutrition (F1000Research)', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11234080/' },
      { title: 'Effect of Ashwagandha Root Extract in Improving Cardiorespiratory Endurance and Recovery in Healthy Athletic Adults.', meta: 'Choudhary et al. (2021) \u00b7 Journal of Ethnopharmacology', link: 'https://pubmed.ncbi.nlm.nih.gov/33600918/' },
      { title: 'Efficacy of Ashwagandha (KSM-66) in Improving Cardiorespiratory Endurance in Healthy Athletic Adults.', meta: 'Choudhary et al. (2015) \u00b7 Ayu Journal', link: 'https://pubmed.ncbi.nlm.nih.gov/26730141/' }
    ],
    'CoQ10': [
      { title: 'Coenzyme Q10 Supplementation in Athletes: A Systematic Review.', meta: 'Hernández-Camacho et al. (2023) \u00b7 Nutrients', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC10535924/' },
      { title: 'The Effect of Coenzyme Q10 on the Exercise Performance of Cross-Country Skiers.', meta: 'Ylikoski et al. (1997) \u00b7 Molecular Aspects of Medicine', link: 'https://pubmed.ncbi.nlm.nih.gov/9266538/' },
    ],
    'Omega-3 (EPA/DHA)': [
      { title: 'Fish Oil Reduces Heart Rate and Oxygen Consumption During Exercise.', meta: 'Peoples et al. (2008) \u00b7 Journal of Cardiovascular Pharmacology', link: 'https://pubmed.ncbi.nlm.nih.gov/19034030/' },
      { title: 'Omega-3 Fatty Acids Supplementation Improves Endothelial Function and Maximal Oxygen Uptake in Endurance-Trained Athletes.', meta: 'Żebrowska et al. (2015) \u00b7 European Journal of Sport Science', link: 'https://pubmed.ncbi.nlm.nih.gov/25176010/' },
      { title: 'Six Weeks of Either EPA-Rich or DHA-Rich Omega-3 Supplementation Alters Submaximal Exercise Physiology in Endurance Trained Male Amateurs.', meta: 'Blannin et al. (2025) \u00b7 Frontiers in Nutrition', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC12417169/' }
    ]
  },
  fatloss: {
    'Ashwagandha': [
      { title: 'Body Weight Management in Adults Under Chronic Stress Through Treatment With Ashwagandha Root Extract.', meta: 'Choudhary et al. (2017) \u00b7 Journal of Evidence-Based Complementary & Alternative Medicine', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC5871210/' },
      { title: 'Efficacy and Safety of Ashwagandha Root Extract on Stress and Weight Management in Adults.', meta: 'Kelgane et al. (2025) \u00b7 Frontiers in Nutrition', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC12863098/' },
      { title: 'Clinical Evaluation of the Pharmacological Impact of Ashwagandha Root Extract on Sleep in Healthy Volunteers and Insomnia Patients.', meta: 'Langade et al. (2021) \u00b7 Journal of Ethnopharmacology', link: 'https://pubmed.ncbi.nlm.nih.gov/32818573/' }
    ],
    'Magnesium': [
      { title: 'Effectiveness of Magnesium Supplementation on Sleep Quality, HRV, and Readiness in Adults with Poor Sleep Quality.', meta: 'Sowah et al. (2023) \u00b7 Medical Research Archives', link: 'https://esmed.org/MRA/mra/article/view/5410' }
    ],
    'Omega-3 (EPA/DHA)': [
      { title: 'Effect of Omega-3 Long-Chain Polyunsaturated Fatty Acid Supplementation on Heart Rate: A Meta-Analysis of Randomized Controlled Trials.', meta: 'Hidayat et al. (2018) \u00b7 European Journal of Clinical Nutrition', link: 'https://www.nature.com/articles/s41430-017-0052-3' },
      { title: 'Omega-3 Fatty Acid Supplementation for 12 Weeks Increases Resting and Exercise Metabolic Rate in Healthy Community-Dwelling Older Females.', meta: 'Logan & Spriet (2015) \u00b7 PLOS ONE', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC4682991/' },
      { title: 'Effect of Docosahexaenoic Acid and Eicosapentaenoic Acid Supplementation on Sleep Quality in Healthy Subjects: A Randomized, Double-Blinded, Placebo-Controlled Trial.', meta: 'Yoneyama et al. (2022) \u00b7 Nutrients', link: 'https://pubmed.ncbi.nlm.nih.gov/36235788/' }
    ],
    'Probiotics': [
      { title: 'Effect of Lactobacillus gasseri SBT2055 in Fermented Milk on Abdominal Adiposity in Adults in a Randomised Controlled Trial.', meta: 'Kadooka et al. (2013) \u00b7 British Journal of Nutrition', link: 'https://pubmed.ncbi.nlm.nih.gov/23614897/' },
      { title: 'Bifidobacterium longum 1714 Improves Sleep Quality and Aspects of Well-Being in Healthy Adults: A Randomized, Double-Blind, Placebo-Controlled Clinical Trial.', meta: 'Patterson et al. (2024) \u00b7 Scientific Reports', link: 'https://www.nature.com/articles/s41598-024-53810-w' }
    ]
  },
  recovery: {
    'Omega-3 (EPA/DHA)': [
      { title: 'Omega-3 Polyunsaturated Fatty Acids and Heart Rate Variability.', meta: 'Mozaffarian et al. (2011) \u00b7 Progress in Cardiovascular Diseases', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC3217222/' },
      { title: 'DHA-Rich Fish Oil Increases the Omega-3 Index in Healthy Adults and Slows Resting Heart Rate without Altering Cardiac Autonomic Reflex Modulation.', meta: 'Peoples et al. (2021) \u00b7 Journal of the American College of Nutrition', link: 'https://pubmed.ncbi.nlm.nih.gov/34379997/' },
      { title: 'Differential Effects of DHA- and EPA-Rich Oils on Sleep in Healthy Young Adults: A Randomized Controlled Trial.', meta: 'Stonehouse et al. (2021) \u00b7 Nutrients', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC7830450/' }
    ],
    'Magnesium': [
      { title: 'Long-term HRV Analysis Shows Stress Reduction by Magnesium Intake.', meta: 'Wienecke & Nolden (2016) \u00b7 MMW Fortschritte der Medizin', link: 'https://pubmed.ncbi.nlm.nih.gov/27933574/' }
    ],
    'CoQ10': [
      { title: 'The Effects of Coenzyme Q10 Supplementation on Biomarkers of Exercise-Induced Muscle Damage, Physical Performance, and Oxidative Stress: A GRADE-Assessed Systematic Review and Dose-Response Meta-Analysis of Randomized Controlled Trials.', meta: 'Drobnic et al. (2024) \u00b7 Clinical Nutrition ESPEN', link: 'https://pubmed.ncbi.nlm.nih.gov/38479900/' },
      { title: 'Coenzyme Q10 Supplementation Reduces Fatigue in Healthy Adults: A Systematic Review and Meta-Analysis of Randomized Controlled Trials.', meta: 'Hidouri et al. (2022) \u00b7 Frontiers in Pharmacology', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC9449413/' }
    ],
    'Probiotics': [
      { title: 'A Lactobacillus Consortium Provides Insights into the Sleep-Exercise-Microbiome Nexus in Proof of Concept Studies of Elite Athletes and in the General Population.', meta: 'Mohr et al. (2024) \u00b7 Microbiome', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11697739/' },
      { title: 'Multi-Strain Probiotic Improves Subjective Sleep Quality with No Impact on Body Composition, Hemodynamics, and Physical Activity.', meta: 'Troutt et al. (2024) \u00b7 Journal of Dietary Supplements', link: 'https://pubmed.ncbi.nlm.nih.gov/38350465/' }
    ]
  },
  sleep: {
    'Magnesium': [
      { title: 'The Role of Magnesium in Sleep Health: a Systematic Review of Available Literature.', meta: 'Arab et al. (2022) \u00b7 Biological Trace Element Research', link: 'https://pubmed.ncbi.nlm.nih.gov/35184264/' },
      { title: 'Examining the Effects of Supplemental Magnesium on Self-Reported Anxiety and Sleep Quality: A Systematic Review.', meta: 'Rawji et al. (2024) \u00b7 Cureus', link: 'https://pubmed.ncbi.nlm.nih.gov/38817505/' },
      { title: 'Effectiveness of Magnesium Supplementation on Sleep Quality and Mood for Adults with Poor Sleep Quality: A Randomized Double-Blind Placebo-Controlled Crossover Pilot Trial.', meta: 'Breus et al. (2024) \u00b7 Medical Research Archives', link: 'https://esmed.org/MRA/mra/article/view/5410' }
    ],
    'Ashwagandha': [
      { title: 'A Randomized, Double-Blind, Placebo-Controlled Study to Evaluate the Effects of Ashwagandha (Withania somnifera) Extract on Sleep Quality in Healthy Adults.', meta: 'Deshpande et al. (2020) \u00b7 Sleep Medicine', link: 'https://pubmed.ncbi.nlm.nih.gov/32540634/' },
      { title: 'Clinical Evaluation of the Pharmacological Impact of Ashwagandha Root Extract on Sleep in Healthy Volunteers and Insomnia Patients: A Double-Blind, Randomized, Parallel-Group, Placebo-Controlled Study.', meta: 'Langade et al. (2020) \u00b7 Journal of Ethnopharmacology', link: 'https://pubmed.ncbi.nlm.nih.gov/32818573/' }
    ],
    'Zinc': [
      { title: 'Effects of Zinc Supplementation on Sleep Quality in Humans: A Systematic Review of Randomized Controlled Trials.', meta: 'Jazinaki et al. (2024) \u00b7 Health Science Reports (Wiley)', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11456512/' }
    ],
    'Probiotics': [
      { title: 'Bifidobacterium longum 1714 Improves Sleep Quality and Aspects of Well-Being in Healthy Adults: A Randomized, Double-Blind, Placebo-Controlled Clinical Trial.', meta: 'Patterson et al. (2024) \u00b7 Scientific Reports (Nature)', link: 'https://www.nature.com/articles/s41598-024-53810-w' }
    ]
  },
  longevity: {
    'Omega-3 (EPA/DHA)': [
      { title: 'Effect of Omega-3 Long-Chain Polyunsaturated Fatty Acid Supplementation on Heart Rate: A Meta-Analysis of Randomized Controlled Trials.', meta: 'Hidayat et al. (2018) \u00b7 European Journal of Clinical Nutrition', link: 'https://www.nature.com/articles/s41430-017-0052-3' },
      { title: 'Differential Effects of DHA- and EPA-Rich Oils on Sleep in Healthy Young Adults: A Randomized Controlled Trial.', meta: 'Patan et al. (2021) \u00b7 Nutrients', link: 'https://pubmed.ncbi.nlm.nih.gov/33467135/' },
      { title: 'Effects of 12 Weeks of Omega-3 Fatty Acid Supplementation in Long-Distance Runners.', meta: 'Tomczyk et al. (2022) \u00b7 Medicine & Science in Sports & Exercise', link: 'https://pubmed.ncbi.nlm.nih.gov/36161864/' }
    ],
    'CoQ10': [
      { title: 'CoQ10 supplementation and exercise performance — VO2max and anaerobic threshold in healthy adults.', meta: 'Ylikoski et al. (1997) \u00b7 Molecular Aspects of Medicine', link: 'https://pubmed.ncbi.nlm.nih.gov/9266538/' },
      { title: 'Effects of CoQ10 supplementation on biomarkers of exercise-induced muscle damage, physical performance, and oxidative stress — dose-response meta-analysis of RCTs.', meta: 'Naderi et al. (2024) \u00b7 Clinical Nutrition ESPEN', link: 'https://pubmed.ncbi.nlm.nih.gov/38479900/' }
    ],
    'Vitamin D3': [
      { title: 'Vitamin D Supplementation and Sleep: A Systematic Review and Meta-Analysis of Intervention Studies.', meta: 'Abboud M. (2022) \u00b7 Nutrients', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC8912284/' },
      { title: 'Effect of Vitamin D Supplementation on Cardiovascular Disease Risk Factors and Exercise Performance in Healthy Participants: A Randomized Placebo-Controlled Preliminary Study.', meta: 'Pilz et al. (2016) \u00b7 American Journal of Cardiovascular Disease', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC4973406/' },
      { title: 'Higher Serum Vitamin D Concentrations Are Associated with Longer Leukocyte Telomere Length in Women', meta: 'Richards et al. (2007) \u00b7 American Journal of Clinical Nutrition', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC2196219/' }
    ],
    'Magnesium': [
      { title: 'Effects of Magnesium Supplementation on Blood Pressure: A Meta-Analysis of Randomized Double-Blind Placebo-Controlled Trials.', meta: 'Zhang et al. (2016) \u00b7 Hypertension', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC4947579/' },
      { title: 'The Role of Magnesium in Sleep Health: a Systematic Review of Available Literature.', meta: 'Arab et al. (2022) \u00b7 Biological Trace Element Research', link: 'https://pubmed.ncbi.nlm.nih.gov/35184264/' }
    ]
  },
  energy: {
    'Vitamin B12': [
      { title: 'Effects of Vitamin B12 on Performance and Circadian Rhythm in Normal Subjects.', meta: 'Okawa et al. (1990) \u00b7 Sleep', link: 'https://pubmed.ncbi.nlm.nih.gov/8914118/' },
      { title: 'A Functional Evaluation of Anti-Fatigue and Exercise Performance Improvement Following Vitamin B Complex Supplementation in Healthy Humans.', meta: 'Yu et al. (2023) \u00b7 International Journal of Medical Sciences', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC10542023/' }
    ],
    'CoQ10': [
      { title: 'Effectiveness of Coenzyme Q10 Supplementation for Reducing Fatigue: A Systematic Review and Meta-Analysis of Randomized Controlled Trials.', meta: 'Tsai et al. (2022) \u00b7 Frontiers in Pharmacology', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC9449413/' },
      { title: 'Ubiquinol Supplementation Enhances Peak Power Production in Trained Athletes: A Double-Blind, Placebo Controlled Study.', meta: 'Alf et al. (2013) \u00b7 Journal of the International Society of Sports Nutrition', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC3661336/' }
    ],
    'Magnesium': [
      { title: 'Long-Term HRV Analysis Shows Stress Reduction by Magnesium Intake.', meta: 'Wienecke & Nolden (2016) \u00b7 MMW Fortschritte der Medizin', link: 'https://pubmed.ncbi.nlm.nih.gov/27933574/' },
      { title: 'Effectiveness of Magnesium Supplementation on Sleep Quality and Mood for Adults with Poor Sleep Quality: A Randomized Double-Blind Placebo-Controlled Crossover Pilot Trial.', meta: 'Breus, Hooper, Lynch & Hausenblas (2024) \u00b7 Medical Research Archives', link: 'https://esmed.org/MRA/mra/article/view/5410' }
    ],
    'Omega-3 (EPA/DHA)': [
      { title: 'Differential Effects of DHA- and EPA-Rich Oils on Sleep in Healthy Young Adults: A Randomized Controlled Trial.', meta: 'Patan et al. (2021) \u00b7 Nutrients', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC7830450/' },
      { title: 'Six Weeks of Either EPA-Rich or DHA-Rich Omega-3 Supplementation Alters Submaximal Exercise Physiology in Endurance Trained Male Amateurs.', meta: 'Blannin et al. (2025) \u00b7 Frontiers in Nutrition', link: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC12417169/' }
    ]
  }
};
window.goalResearchArticles = goalResearchArticles;


const metric_graph = {
        "VO2 Max": {
         "30": {
                "placebo": "+2.7%",
                "treatment": "+2%",
                "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
              },
          "60": {
            "placebo": "+2.7%",
            "treatment": "+8%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+2.7%",
            "treatment": "+10%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "1RM": {
           "30": {
                "placebo": "+2.7%",
                "treatment": "+5%",
                "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
              },
          "60": {
            "placebo": "+2.7%",
            "treatment": "+10%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+8%",
            "treatment": "+14%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "RHR": {
          "30": {
            "placebo": "+2.7%",
            "treatment": "-0 BPM",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "60": {
            "placebo": "+2.7%",
            "treatment": "-1 BPM",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+0%",
            "treatment": "-4 BPM",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Power": {
          "30": {
            "placebo": "+2.7%",
            "treatment": "+1%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "60": {
            "placebo": "+2.7%",
            "treatment": "+6%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+0%",
            "treatment": "+9%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "HRV": {
          "30": {
            "placebo": "+2.7%",
            "treatment": "+5%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "60": {
            "placebo": "+2.7%",
            "treatment": "+10%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+0%",
            "treatment": "+18%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Training Intensity": {
            "30": {
                "placebo": "+2.7%",
                "treatment": "+3%",
                "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
              },
          "60": {
            "placebo": "+2.7%",
            "treatment": "+10%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
            "90": {
              "placebo": "+0%",
              "treatment": "+14%",
              "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
            }
          },
        "BMR": {
            "30": {
                "placebo": "+2.7%",
                "treatment": "+1%",
                "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
              },
          "60": {
            "placebo": "+2.7%",
            "treatment": "+3%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+0%",
            "treatment": "+8%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Quality": {
            "30": {
                "placebo": "+2.7%",
                "treatment": "+9%",
                "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
              },
          "60": {
            "placebo": "+2.7%",
            "treatment": "+13%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
            "90": {
              "placebo": "+0%",
              "treatment": "+15%",
              "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
            }
          },
        "Deep & REM": {
            "30": {
                "placebo": "+2.7%",
                "treatment": "+10%",
                "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
              },
          "60": {
            "placebo": "+2.7%",
            "treatment": "+15%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+0%",
            "treatment": "+20%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Latency": {
            "30": {
                "placebo": "+2.7%",
                "treatment": "-10%",
                "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
              },
          "60": {
            "placebo": "+2.7%",
            "treatment": "-28%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+0%",
            "treatment": "-35%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        },
        "Sleep Disruptions": {
            "30": {
                "placebo": "+2.7%",
                "treatment": "-7%",
                "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
              },
          "60": {
            "placebo": "+2.7%",
            "treatment": "-20%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          },
          "90": {
            "placebo": "+0%",
            "treatment": "-40%",
            "URL": "https://pubmed.ncbi.nlm.nih.gov/1874236/"
          }
        }
        
}



const rankingMetricsScore = {
    "apple_watch": {
        "Heart": {
            "hrv": 4,
            "rhr": 2
        },
        "Training Load": {
            "training_load": 4,
            "workout_effort": 3,
            "workout_duration": 1
        },
        "Vitals": {
            "stress": 4,
            "sleep_quality": 3,
            "hrv": 3,
            "bmr": 1
        },
        "Cardio Fitness": {
            "vo2_max": 4
        },
        "Sleep": {
            "deep_sleep": 4,
            "rem_sleep": 3,
            "sleep_latency": 2,
            "sleep_disruptions": 2
        }
    },
    "whoop": {
        "Stress": {
            "stress": 4,
            "hrv": 3,
            "rhr": 2
        },
        "Strain": {
            "hr_zones": 4,
            "workout_duration": 3,
            "workout_effort": 2
        },
        "Healthspan": {
            "healthspan": 4,
            "vo2_max": 3,
            "sleep_quality": 3,
            "rhr": 2
        },
        "Sleep": {
            "deep_sleep": 4,
            "rem_sleep": 3,
            "sleep_latency": 2,
            "sleep_disruptions": 2
        },
        "Recovery": {
            "hrv": 4,
            "rhr": 3,
            "sleep_quality": 2
        }
    },
    "garmin": {
        "Fitness Age": {
            "vo2_max": 4,
            "rhr": 3,
            "sleep_quality": 2
        },
        "Training Readiness": {
            "training_load": 4,
            "recovery": 3,
            "sleep_quality": 2
        },
        "VO2 Max": {
            "vo2_max": 4,
            "rhr": 3,
            "pace": 2
        },
        "Body Battery": {
            "recovery": 4,
            "stress": 3,
            "hrv": 2
        },
        "Sleep": {
            "deep_sleep": 4,
            "rem_sleep": 3,
            "sleep_latency": 2,
            "sleep_disruptions": 2
        }
    }
};

window.rankingMetricsScore = rankingMetricsScore;


const metricsScorePerSupplement = {
  "vo2_max": {
    "Ashwagandha": 27,
    "Iron": 26,
    "Vitamin D": 25,
    "Omega 3": 24,
    "Berberine": 23,
    "Rhodiola Rosea": 22,
    "Calcium": 21,
    "Folic Acid": 20,
    "Vitamin B12": 19,
    "Magnesium": 18,
    "CoQ10": 17,
    "Acetyl L-Carnitine": 16,
    "Curcumin": 15,
    "Vitamin C": 14,
    "Probiotics": 13,
    "Resveratrol": 12,
    "Tongkat Ali": 11,
    "Vitamin E": 10,
    "L-Tyrosine": 9,
    "Zinc": 8,
    "L-Theanine": 7,
    "Alpha GPC": 6,
    "Apigenin": 5,
    "Inositol": 4,
    "Biotin": 3,
    "Vitamin B2": 2,
    "Vitamin B6": 1
  },
  "recovery": {
    "Curcumin": 27,
    "Rhodiola Rosea": 26,
    "Magnesium": 25,
    "Ashwagandha": 24,
    "Probiotics": 23,
    "Vitamin D": 22,
    "Calcium": 21,
    "Vitamin E": 20,
    "Iron": 19,
    "CoQ10": 18,
    "Omega 3": 17,
    "Vitamin C": 16,
    "Zinc": 15,
    "Vitamin B12": 14,
    "Acetyl L-Carnitine": 13,
    "Resveratrol": 12,
    "L-Tyrosine": 11,
    "Vitamin B6": 10,
    "L-Theanine": 9,
    "Alpha GPC": 8,
    "Tongkat Ali": 7,
    "Apigenin": 6,
    "Folic Acid": 5,
    "Berberine": 4,
    "Vitamin B2": 3,
    "Inositol": 2,
    "Biotin": 1
  },
  "training_load": {
    "Omega 3": 27,
    "Zinc": 26,
    "Vitamin C": 25,
    "Ashwagandha": 24,
    "Probiotics": 23,
    "Magnesium": 22,
    "Vitamin D": 21,
    "Rhodiola Rosea": 20,
    "Calcium": 19,
    "Inositol": 18,
    "CoQ10": 17,
    "Resveratrol": 16,
    "L-Theanine": 15,
    "Vitamin E": 14,
    "Iron": 13,
    "Alpha GPC": 12,
    "Folic Acid": 11,
    "Vitamin B12": 10,
    "Biotin": 9,
    "Curcumin": 8,
    "Apigenin": 7,
    "L-Tyrosine": 6,
    "Acetyl L-Carnitine": 5,
    "Vitamin B2": 4,
    "Vitamin B6": 3,
    "Tongkat Ali": 2,
    "Berberine": 1
  },
  "workout_effort": {
    "Iron": 27,
    "Ashwagandha": 26,
    "CoQ10": 25,
    "Acetyl L-Carnitine": 24,
    "Probiotics": 23,
    "Curcumin": 22,
    "Berberine": 21,
    "Vitamin B12": 20,
    "Resveratrol": 19,
    "Biotin": 18,
    "Vitamin C": 17,
    "Rhodiola Rosea": 16,
    "Vitamin B2": 15,
    "L-Theanine": 14,
    "Omega 3": 13,
    "Apigenin": 12,
    "Magnesium": 11,
    "Tongkat Ali": 10,
    "Calcium": 9,
    "Zinc": 8,
    "Alpha GPC": 7,
    "Folic Acid": 6,
    "Vitamin B6": 5,
    "Inositol": 4,
    "L-Tyrosine": 3,
    "Vitamin E": 2,
    "Vitamin D": 1
  },
  "rhr": {
    "L-Theanine": 27,
    "Iron": 26,
    "Omega 3": 25,
    "CoQ10": 24,
    "Probiotics": 23,
    "Inositol": 22,
    "Vitamin B12": 21,
    "Folic Acid": 20,
    "Vitamin C": 19,
    "Ashwagandha": 18,
    "Curcumin": 17,
    "Vitamin B2": 16,
    "Magnesium": 15,
    "Zinc": 14,
    "Apigenin": 13,
    "Vitamin D": 12,
    "Calcium": 11,
    "Berberine": 10,
    "Vitamin B6": 9,
    "Acetyl L-Carnitine": 8,
    "L-Tyrosine": 7,
    "Alpha GPC": 6,
    "Rhodiola Rosea": 5,
    "Resveratrol": 4,
    "Vitamin E": 3,
    "Tongkat Ali": 2,
    "Biotin": 1
  },
  "hrv": {
    "Berberine": 27,
    "Omega 3": 26,
    "Iron": 25,
    "Rhodiola Rosea": 24,
    "Ashwagandha": 23,
    "Probiotics": 22,
    "Magnesium": 21,
    "CoQ10": 20,
    "Curcumin": 19,
    "Inositol": 18,
    "Resveratrol": 17,
    "Zinc": 16,
    "L-Tyrosine": 15,
    "L-Theanine": 14,
    "Calcium": 13,
    "Folic Acid": 12,
    "Vitamin D": 11,
    "Vitamin C": 10,
    "Vitamin B12": 9,
    "Vitamin B6": 8,
    "Acetyl L-Carnitine": 7,
    "Alpha GPC": 6,
    "Apigenin": 5,
    "Vitamin E": 4,
    "Tongkat Ali": 3,
    "Biotin": 2,
    "Vitamin B2": 1
  },
  "strain": {
    "Iron": 27,
    "Berberine": 26,
    "CoQ10": 25,
    "Ashwagandha": 24,
    "Zinc": 23,
    "Rhodiola Rosea": 22,
    "Folic Acid": 21,
    "Omega 3": 20,
    "Vitamin B12": 19,
    "Vitamin D": 18,
    "Inositol": 17,
    "Magnesium": 16,
    "Probiotics": 15,
    "Vitamin B2": 14,
    "Vitamin C": 13,
    "L-Theanine": 12,
    "Resveratrol": 11,
    "Acetyl L-Carnitine": 10,
    "Biotin": 9,
    "Curcumin": 8,
    "Vitamin E": 7,
    "Calcium": 6,
    "Vitamin B6": 5,
    "Alpha GPC": 4,
    "L-Tyrosine": 3,
    "Apigenin": 2,
    "Tongkat Ali": 1
  },
  "hr_zones": {
    "Ashwagandha": 27,
    "Vitamin B2": 26,
    "Vitamin E": 25,
    "Berberine": 24,
    "Omega 3": 23,
    "CoQ10": 22,
    "Curcumin": 21,
    "Vitamin B12": 20,
    "Vitamin D": 19,
    "Acetyl L-Carnitine": 18,
    "Iron": 17,
    "L-Theanine": 16,
    "Resveratrol": 15,
    "Magnesium": 14,
    "Rhodiola Rosea": 13,
    "Calcium": 12,
    "Zinc": 11,
    "Folic Acid": 10,
    "Inositol": 9,
    "Probiotics": 8,
    "Vitamin C": 7,
    "L-Tyrosine": 6,
    "Alpha GPC": 5,
    "Apigenin": 4,
    "Biotin": 3,
    "Tongkat Ali": 2,
    "Vitamin B6": 1
  },
  "workout_duration": {
    "Iron": 27,
    "Berberine": 26,
    "Curcumin": 25,
    "Acetyl L-Carnitine": 24,
    "Ashwagandha": 23,
    "CoQ10": 22,
    "Probiotics": 21,
    "Vitamin E": 20,
    "Resveratrol": 19,
    "Rhodiola Rosea": 18,
    "Vitamin B12": 17,
    "Magnesium": 16,
    "Vitamin D": 15,
    "Omega 3": 14,
    "Vitamin B2": 13,
    "Vitamin C": 12,
    "Folic Acid": 11,
    "L-Theanine": 10,
    "Tongkat Ali": 9,
    "Zinc": 8,
    "Apigenin": 7,
    "Calcium": 6,
    "Inositol": 5,
    "L-Tyrosine": 4,
    "Vitamin B6": 3,
    "Alpha GPC": 2,
    "Biotin": 1
  },
  "stress": {
    "Rhodiola Rosea": 27,
    "Ashwagandha": 26,
    "Curcumin": 25,
    "Magnesium": 24,
    "CoQ10": 23,
    "Inositol": 22,
    "Probiotics": 21,
    "Iron": 20,
    "Folic Acid": 19,
    "Vitamin B12": 18,
    "Vitamin D": 17,
    "Vitamin C": 16,
    "Zinc": 15,
    "L-Theanine": 14,
    "Omega 3": 13,
    "Berberine": 12,
    "Vitamin B2": 11,
    "Alpha GPC": 10,
    "Apigenin": 9,
    "Vitamin B6": 8,
    "Resveratrol": 7,
    "Acetyl L-Carnitine": 6,
    "Biotin": 5,
    "L-Tyrosine": 4,
    "Vitamin E": 3,
    "Calcium": 2,
    "Tongkat Ali": 1
  },
  "sleep_quality": {
    "L-Theanine": 27,
    "Zinc": 26,
    "Ashwagandha": 25,
    "Magnesium": 24,
    "Probiotics": 23,
    "Curcumin": 22,
    "Vitamin D": 21,
    "Omega 3": 20,
    "CoQ10": 19,
    "Iron": 18,
    "Vitamin B6": 17,
    "Calcium": 16,
    "Vitamin C": 15,
    "Apigenin": 14,
    "Resveratrol": 13,
    "Rhodiola Rosea": 12,
    "Acetyl L-Carnitine": 11,
    "Vitamin B12": 10,
    "Folic Acid": 9,
    "Tongkat Ali": 8,
    "Vitamin B2": 7,
    "Vitamin E": 6,
    "Inositol": 5,
    "Alpha GPC": 4,
    "Berberine": 3,
    "Biotin": 2,
    "L-Tyrosine": 1
  },
  "bmr": {
    "Berberine": 27,
    "Magnesium": 26,
    "CoQ10": 25,
    "Vitamin C": 24,
    "Inositol": 23,
    "Ashwagandha": 22,
    "Vitamin B12": 21,
    "Folic Acid": 20,
    "Vitamin B2": 19,
    "Vitamin D": 18,
    "Vitamin E": 17,
    "Calcium": 16,
    "Omega 3": 15,
    "Curcumin": 14,
    "Iron": 13,
    "Resveratrol": 12,
    "Rhodiola Rosea": 11,
    "Biotin": 10,
    "Tongkat Ali": 9,
    "Zinc": 8,
    "L-Tyrosine": 7,
    "L-Theanine": 6,
    "Acetyl L-Carnitine": 5,
    "Probiotics": 4,
    "Vitamin B6": 3,
    "Apigenin": 2,
    "Alpha GPC": 1
  },
  "deep_sleep": {
    "Ashwagandha": 27,
    "Magnesium": 26,
    "L-Theanine": 25,
    "Vitamin D": 24,
    "Probiotics": 23,
    "Omega 3": 22,
    "Zinc": 21,
    "Iron": 20,
    "Acetyl L-Carnitine": 19,
    "CoQ10": 18,
    "Vitamin B6": 17,
    "Resveratrol": 16,
    "Calcium": 15,
    "Rhodiola Rosea": 14,
    "Tongkat Ali": 13,
    "Curcumin": 12,
    "Vitamin B12": 11,
    "Vitamin C": 10,
    "Folic Acid": 9,
    "Vitamin B2": 8,
    "Alpha GPC": 7,
    "Inositol": 6,
    "Berberine": 5,
    "Vitamin E": 4,
    "Apigenin": 3,
    "Biotin": 2,
    "L-Tyrosine": 1
  },
  "rem_sleep": {
    "Magnesium": 27,
    "L-Theanine": 26,
    "Ashwagandha": 25,
    "Berberine": 24,
    "Probiotics": 23,
    "Omega 3": 22,
    "Vitamin D": 21,
    "Acetyl L-Carnitine": 20,
    "Vitamin C": 19,
    "Rhodiola Rosea": 18,
    "Iron": 17,
    "Vitamin B2": 16,
    "Vitamin B6": 15,
    "CoQ10": 14,
    "Zinc": 13,
    "Apigenin": 12,
    "Calcium": 11,
    "Curcumin": 10,
    "Resveratrol": 9,
    "Vitamin B12": 8,
    "Alpha GPC": 7,
    "Biotin": 6,
    "Folic Acid": 5,
    "Tongkat Ali": 4,
    "Inositol": 3,
    "Vitamin E": 2,
    "L-Tyrosine": 1
  },
  "sleep_latency": {
    "L-Theanine": 27,
    "Ashwagandha": 26,
    "Omega 3": 25,
    "Acetyl L-Carnitine": 24,
    "Probiotics": 23,
    "Zinc": 22,
    "Magnesium": 21,
    "Vitamin D": 20,
    "Calcium": 19,
    "Apigenin": 18,
    "CoQ10": 17,
    "Iron": 16,
    "Rhodiola Rosea": 15,
    "Vitamin C": 14,
    "Berberine": 13,
    "Folic Acid": 12,
    "Curcumin": 11,
    "Resveratrol": 10,
    "Vitamin B6": 9,
    "Tongkat Ali": 8,
    "Inositol": 7,
    "Vitamin B12": 6,
    "Vitamin E": 5,
    "Alpha GPC": 4,
    "Biotin": 3,
    "L-Tyrosine": 2,
    "Vitamin B2": 1
  },
  "sleep_disruptions": {
    "L-Theanine": 27,
    "Ashwagandha": 26,
    "Magnesium": 25,
    "Iron": 24,
    "Probiotics": 23,
    "Rhodiola Rosea": 22,
    "Zinc": 21,
    "Calcium": 20,
    "Omega 3": 19,
    "Vitamin B12": 18,
    "Vitamin B6": 17,
    "Vitamin D": 16,
    "Curcumin": 15,
    "Resveratrol": 14,
    "Folic Acid": 13,
    "Vitamin C": 12,
    "CoQ10": 11,
    "Acetyl L-Carnitine": 10,
    "Apigenin": 9,
    "Inositol": 8,
    "Vitamin E": 7,
    "Tongkat Ali": 6,
    "Vitamin B2": 5,
    "Berberine": 4,
    "Alpha GPC": 3,
    "Biotin": 2,
    "L-Tyrosine": 1
  },
  "healthspan": {
    "Magnesium": 27,
    "Curcumin": 26,
    "Resveratrol": 25,
    "Calcium": 24,
    "Probiotics": 23,
    "Berberine": 22,
    "Folic Acid": 21,
    "Vitamin E": 20,
    "CoQ10": 19,
    "Vitamin B12": 18,
    "Vitamin D": 17,
    "Acetyl L-Carnitine": 16,
    "Rhodiola Rosea": 15,
    "Tongkat Ali": 14,
    "Iron": 13,
    "Ashwagandha": 12,
    "Omega 3": 11,
    "Zinc": 10,
    "Alpha GPC": 9,
    "L-Theanine": 8,
    "Apigenin": 7,
    "Inositol": 6,
    "L-Tyrosine": 5,
    "Vitamin C": 4,
    "Biotin": 3,
    "Vitamin B2": 2,
    "Vitamin B6": 1
  },
  "pace": {
    "Iron": 27,
    "Ashwagandha": 26,
    "Berberine": 25,
    "CoQ10": 24,
    "Resveratrol": 23,
    "Tongkat Ali": 22,
    "Omega 3": 21,
    "Acetyl L-Carnitine": 20,
    "Curcumin": 19,
    "Vitamin B12": 18,
    "Vitamin D": 17,
    "Vitamin E": 16,
    "Probiotics": 15,
    "Rhodiola Rosea": 14,
    "L-Theanine": 13,
    "Vitamin B6": 12,
    "Vitamin B2": 11,
    "Zinc": 10,
    "Alpha GPC": 9,
    "Inositol": 8,
    "L-Tyrosine": 7,
    "Folic Acid": 6,
    "Vitamin C": 5,
    "Magnesium": 4,
    "Calcium": 3,
    "Apigenin": 2,
    "Biotin": 1
  },
  "body_composition": {
    "Curcumin": 27,
    "Omega 3": 26,
    "Acetyl L-Carnitine": 25,
    "Berberine": 24,
    "Probiotics": 23,
    "Resveratrol": 22,
    "Ashwagandha": 21,
    "Calcium": 20,
    "Magnesium": 19,
    "Vitamin D": 18,
    "Zinc": 17,
    "Inositol": 16,
    "Vitamin B2": 15,
    "CoQ10": 14,
    "Folic Acid": 13,
    "Vitamin B12": 12,
    "Vitamin E": 11,
    "Biotin": 10,
    "Rhodiola Rosea": 9,
    "Vitamin C": 8,
    "Iron": 7,
    "L-Theanine": 6,
    "Vitamin B6": 5,
    "L-Tyrosine": 4,
    "Alpha GPC": 3,
    "Apigenin": 2,
    "Tongkat Ali": 1
  }
}

window.metricsScorePerSupplement = metricsScorePerSupplement;

const metricsDescription = {
  "vo2_max": "Maximal oxygen uptake. The strongest single predictor of cardiovascular fitness and long-term health.",
  "recovery": "A readiness score showing how prepared your body is to perform, based on strain, sleep, and recovery signals.",
  "training_load": "The cumulative physical demand placed on your body over time, helping assess whether you are undertraining or overreaching.",
  "workout_effort": "A measure of how hard a session felt physiologically, capturing the intensity your body actually experienced.",
  "rhr": "Resting heart rate reflects cardiovascular efficiency and recovery — a useful signal for training load and stress.",
  "hrv": "Heart rate variability indicates autonomic balance and recovery capacity — sensitive to sleep, stress, and training.",
  "strain": "A measure of total cardiovascular stress placed on the body, often used to track how demanding a day or session was.",
  "hr_zones": "Heart rate zones show how much time you spend at different intensities, helping assess effort, endurance, and recovery balance.",
  "workout_duration": "The total time spent training, useful for understanding overall volume and how much work your body is absorbing.",
  "stress": "A signal of physiological load on the body, influenced by lifestyle, recovery, training, and nervous system balance.",
  "sleep_quality": "An overall view of how restorative your sleep was, combining duration, efficiency, stages, and interruptions.",
  "bmr": "Basal metabolic rate is the amount of energy your body needs at rest to maintain essential functions like breathing and circulation.",
  "deep_sleep": "Deep sleep is the most physically restorative sleep stage, essential for recovery, tissue repair, and immune function.",
  "rem_sleep": "REM sleep supports cognitive recovery, memory consolidation, mood regulation, and overall brain function.",
  "sleep_latency": "Sleep latency is the time it takes to fall asleep, offering insight into nervous system balance and sleep readiness.",
  "sleep_disruptions": "Sleep disruptions track how often sleep is interrupted, which can reduce recovery quality even if total sleep looks sufficient.",
  "healthspan": "Healthspan reflects how well your body maintains performance, resilience, and vitality across time, not just lifespan alone.",
  "pace": "Pace measures how quickly you cover distance, making it a practical indicator of endurance performance and running efficiency.",
  "body_composition": "Body composition reflects the balance of fat mass and lean mass, giving a clearer picture of physical progress than weight alone.",
};

window.metricsDescription = metricsDescription;


const metricCategoryTag = {
  "vo2_max": { tag: "Cardio Fitness", color: "#FF453A" },
  "recovery": { tag: "Recovery", color: "#5E5CE6" },
  "training_load": { tag: "Training", color: "#FF9F0A" },
  "workout_effort": { tag: "Training", color: "#FF9F0A" },
  "rhr": { tag: "Heart Health", color: "#30D158" },
  "hrv": { tag: "Recovery", color: "#5E5CE6" },
  "strain": { tag: "Training", color: "#FF9F0A" },
  "hr_zones": { tag: "Cardio Fitness", color: "#FF453A" },
  "workout_duration": { tag: "Training", color: "#FF9F0A" },
  "stress": { tag: "Stress", color: "#BF5AF2" },
  "sleep_quality": { tag: "Sleep", color: "#0A84FF" },
  "bmr": { tag: "Metabolism", color: "#FFD60A" },
  "deep_sleep": { tag: "Sleep", color: "#0A84FF" },
  "rem_sleep": { tag: "Sleep", color: "#0A84FF" },
  "sleep_latency": { tag: "Sleep", color: "#0A84FF" },
  "sleep_disruptions": { tag: "Sleep", color: "#0A84FF" },
  "healthspan": { tag: "Longevity", color: "#64D2FF" },
  "pace": { tag: "Performance", color: "#FF2D55" },
  "body_composition": { tag: "Body Composition", color: "#32D74B" },
};


const metricTagColors = {
  "Cardio Fitness": "#FF453A",
  "Heart Health": "#30D158",
  "Recovery": "#5E5CE6",
  "Training": "#FF9F0A",
  "Stress": "#BF5AF2",
  "Sleep": "#0A84FF",
  "Metabolism": "#FFD60A",
  "Longevity": "#64D2FF",
  "Performance": "#FF2D55",
  "Body Composition": "#32D74B",
};

window.metricCategoryTag = metricCategoryTag;
window.metricTagColors = metricTagColors;


const whyWeRecommendIt = {
  "vo2_max": {
    "Ashwagandha": "Ashwagandha supports VO2 max by lowering cortisol and enhancing mitochondrial efficiency for better energy production.",
    "Vitamin D": "Vitamin D supports VO2 max by powering aerobic energy production and muscular function.",
    "Iron": "Iron supports VO2 max by increasing hemoglobin so your body can carry more oxygen.",
    "CoQ10": "CoQ10 supports VO2 max by enhancing mitochondrial energy production.",
    "Curcumin": "Curcumin supports VO2 max by enhancing mitochondrial efficiency.",
    "Rhodiola Rosea": "Rhodiola Rosea supports VO2 max by boosting mitochondrial efficiency and easing perceived exertion through a calmer stress response.",
    "Resveratrol": "Resveratrol supports VO2 max by enhancing mitochondrial efficiency for better energy production."
  },
  "recovery": {
    "Ashwagandha": "Ashwagandha supports recovery by lowering cortisol and easing stress on the body.",
    "Magnesium": "Magnesium supports recovery by helping reduce muscle soreness and lowering post-exercise cortisol.",
    "Omega 3": "Omega 3 supports recovery by reducing inflammation and soreness while aiding muscle repair.",
    "Vitamin D": "Vitamin D supports recovery by modulating inflammation through immune system regulation.",
    "Iron": "Iron supports recovery by enhancing muscle oxygenation through higher hemoglobin levels.",
    "CoQ10": "CoQ10 supports recovery by reducing oxidative stress in muscle cells.",
    "Probiotics": "Probiotics support recovery by strengthening the gut barrier and supporting immune balance.",
    "Vitamin B12": "Vitamin B12 supports recovery by enhancing red blood cell production to deliver more oxygen to tissues.",
    "Curcumin": "Curcumin supports recovery by reducing inflammation and limiting exercise-induced muscle damage.",
    "Tongkat Ali": "Tongkat Ali supports recovery by helping lower stress and supporting hormonal balance.",
    "Alpha GPC": "Alpha GPC supports recovery by aiding muscle repair and helping restore performance after training.",
    "Rhodiola Rosea": "Rhodiola Rosea supports recovery by lowering cortisol and building resilience under physical and mental strain.",
    "Inositol": "Inositol supports recovery by helping regulate the stress response and supporting mood balance.",
    "Resveratrol": "Resveratrol supports recovery by activating cellular repair pathways and reducing oxidative stress.",
    "Calcium": "Calcium supports recovery by aiding efficient muscle contraction and relaxation.",
    "Folic Acid": "Folic Acid supports recovery by promoting DNA synthesis and repair.",
    "Vitamin B2": "Vitamin B2 supports recovery by enhancing mitochondrial energy production.",
    "Vitamin B6": "Vitamin B6 supports recovery by enhancing neurotransmitter synthesis to reduce muscle fatigue.",
    "Vitamin E": "Vitamin E supports recovery by reducing oxidative stress and inflammation."
  },
  "training_load": {
    "Omega 3": "Omega 3 supports training load by reducing inflammation in muscles.",
    "Magnesium": "Magnesium supports training load by enhancing muscle contraction efficiency and boosting ATP energy production.",
    "Zinc": "Zinc supports training load by reducing exercise-induced oxidative stress.",
    "Resveratrol": "Resveratrol supports training load by enhancing mitochondrial efficiency.",
    "Vitamin C": "Vitamin C supports training load by reducing oxidative stress to enhance muscle recovery."
  },
  "workout_effort": {
    "Ashwagandha": "Ashwagandha supports workout effort by lowering cortisol to make more energy available.",
    "Omega 3": "Omega 3 supports workout effort by helping reduce muscle soreness.",
    "Vitamin D": "Vitamin D supports workout effort by modulating calcium levels for optimal muscle contraction.",
    "Zinc": "Zinc supports workout effort by reducing exercise-induced oxidative stress.",
    "Iron": "Iron supports workout effort by increasing hemoglobin for better oxygen transport and reducing fatigue during exertion.",
    "CoQ10": "CoQ10 supports workout effort by increasing cellular energy production through ATP synthesis.",
    "Probiotics": "Probiotics support workout effort by optimizing nutrient absorption.",
    "Curcumin": "Curcumin supports workout effort by reducing muscle inflammation.",
    "Alpha GPC": "Alpha GPC supports workout effort by raising acetylcholine levels for stronger muscle contractions.",
    "Inositol": "Inositol supports workout effort by improving insulin sensitivity so your body uses energy more efficiently.",
    "Vitamin B2": "Vitamin B2 supports workout effort by enhancing mitochondrial efficiency and cellular energy production.",
    "Vitamin B6": "Vitamin B6 supports workout effort by optimizing neurotransmitter synthesis for better muscle coordination.",
    "Vitamin C": "Vitamin C supports workout effort by reducing oxidative stress in muscles."
  },
  "rhr": {
    "Omega 3": "Omega 3 supports a lower resting heart rate by enhancing vagal tone for better autonomic regulation.",
    "Vitamin B12": "Vitamin B12 supports a lower resting heart rate by enhancing red blood cell production to improve oxygen transport.",
    "L-Theanine": "L-Theanine supports a lower resting heart rate by calming sympathetic nervous system activity.",
    "Alpha GPC": "Alpha GPC supports a lower resting heart rate by improving parasympathetic nervous system activity.",
    "Vitamin E": "Vitamin E supports a lower resting heart rate by decreasing oxidative stress on the cardiovascular system."
  },
  "hrv": {
    "Omega 3": "Omega 3 supports HRV by reducing inflammation and helping your body maintain autonomic balance.",
    "Ashwagandha": "Ashwagandha supports HRV by lowering cortisol and building stress resilience.",
    "Magnesium": "Magnesium supports HRV by lowering cortisol and calming sympathetic nervous system activity.",
    "Iron": "Iron supports HRV by enhancing parasympathetic nervous system activity.",
    "Probiotics": "Probiotics support HRV by modulating the gut-brain axis.",
    "Vitamin B12": "Vitamin B12 supports HRV by enhancing autonomic nervous system balance.",
    "L-Theanine": "L-Theanine supports HRV by reducing sympathetic nervous system activity.",
    "Alpha GPC": "Alpha GPC supports HRV by improving parasympathetic nervous system activity.",
    "L-Tyrosine": "L-Tyrosine supports HRV by increasing dopamine synthesis to enhance autonomic balance.",
    "Vitamin B6": "Vitamin B6 supports HRV by enhancing neurotransmitter synthesis.",
    "Vitamin C": "Vitamin C supports HRV by reducing oxidative stress on the cardiovascular system."
  },
  "strain": {
    "Ashwagandha": "Ashwagandha helps reduce strain by lowering cortisol and building resilience to stress.",
    "Calcium": "Calcium helps reduce strain by strengthening bone density and enhancing muscle contraction efficiency.",
    "CoQ10": "CoQ10 helps reduce strain by improving cellular energy output and helping muscles bounce back from high-intensity efforts.",
    "Iron": "Iron helps reduce strain by improving oxygen delivery and supporting muscular endurance.",
    "L-Theanine": "L-Theanine helps reduce strain by lowering cortisol and modulating alpha brain waves to promote relaxation.",
    "L-Tyrosine": "L-Tyrosine helps reduce strain by increasing dopamine levels to build cognitive resilience.",
    "Magnesium": "Magnesium helps reduce strain by lowering cortisol during periods of severe stress.",
    "Rhodiola Rosea": "Rhodiola Rosea helps reduce strain by modulating cortisol levels to ease stress.",
    "Curcumin": "Curcumin helps reduce strain by lowering inflammation through NF-kB inhibition.",
    "Vitamin B6": "Vitamin B6 helps reduce strain by supporting neurotransmitter synthesis to regulate the stress response.",
    "Vitamin C": "Vitamin C helps reduce strain by enhancing collagen synthesis to strengthen muscle fibers.",
    "Vitamin E": "Vitamin E helps reduce strain by decreasing oxidative stress."
  },
  "hr_zones": {
    "Alpha GPC": "Alpha GPC supports healthier heart rate zones by enhancing cardiovascular efficiency.",
    "Ashwagandha": "Ashwagandha supports healthier heart rate zones by lowering cortisol to enhance cardiovascular efficiency.",
    "Calcium": "Calcium supports healthier heart rate zones by enhancing calcium ion availability for more efficient muscle contraction.",
    "Folic Acid": "Folic Acid supports healthier heart rate zones by enhancing red blood cell production for better oxygen delivery.",
    "L-Theanine": "L-Theanine supports healthier heart rate zones by lowering cortisol to ease stress.",
    "Omega 3": "Omega 3 supports healthier heart rate zones by reducing inflammation and improving blood vessel function.",
    "Rhodiola Rosea": "Rhodiola Rosea supports healthier heart rate zones by reducing cortisol to enhance endurance.",
    "Vitamin B12": "Vitamin B12 supports healthier heart rate zones by enhancing red blood cell production to improve oxygen delivery.",
    "Vitamin B2": "Vitamin B2 supports healthier heart rate zones by enhancing mitochondrial energy production.",
    "Vitamin D": "Vitamin D supports healthier heart rate zones by enhancing calcium regulation for better muscle contraction.",
    "Zinc": "Zinc supports healthier heart rate zones by enhancing cardiovascular efficiency."
  },
  "workout_duration": {
    "Acetyl L-Carnitine": "Acetyl L-Carnitine supports longer workouts by enhancing mitochondrial energy production.",
    "Inositol": "Inositol supports longer workouts by improving insulin sensitivity so your body uses energy more efficiently.",
    "Iron": "Iron supports longer workouts by enhancing mitochondrial efficiency for better energy production.",
    "Rhodiola Rosea": "Rhodiola Rosea supports longer workouts by modulating cortisol levels."
  },
  "stress": {
    "Acetyl L-Carnitine": "Acetyl L-Carnitine helps reduce stress by lowering cortisol levels.",
    "Ashwagandha": "Ashwagandha helps reduce stress by lowering cortisol levels.",
    "Iron": "Iron helps reduce stress by lowering cortisol levels.",
    "L-Theanine": "L-Theanine helps reduce stress by supporting a calmer mental state and relaxation without drowsiness.",
    "Magnesium": "Magnesium helps reduce stress by regulating cortisol levels.",
    "Probiotics": "Probiotics help reduce stress by modulating the gut-brain axis.",
    "Rhodiola Rosea": "Rhodiola Rosea helps reduce stress by modulating cortisol levels.",
    "Tongkat Ali": "Tongkat Ali helps reduce stress by lowering cortisol levels.",
    "Curcumin": "Curcumin helps reduce stress by lowering cortisol and easing psychological symptoms.",
    "Vitamin B12": "Vitamin B12 helps reduce stress by lowering homocysteine levels.",
    "Vitamin B2": "Vitamin B2 helps reduce stress by modulating cortisol levels.",
    "Vitamin C": "Vitamin C helps reduce stress by lowering cortisol levels."
  },
  "sleep_quality": {
    "Acetyl L-Carnitine": "Acetyl L-Carnitine supports sleep quality by reducing oxidative stress in the brain.",
    "Ashwagandha": "Ashwagandha supports sleep quality by lowering cortisol and calming the nervous system for easier sleep onset.",
    "Calcium": "Calcium supports sleep quality by regulating melatonin production.",
    "Iron": "Iron supports sleep quality by reducing restless leg symptoms through increased dopamine synthesis.",
    "L-Theanine": "L-Theanine supports sleep quality by increasing alpha brain wave activity and lowering cortisol to promote relaxation.",
    "Magnesium": "Magnesium supports sleep quality by promoting overnight muscle relaxation.",
    "Omega 3": "Omega 3 supports sleep quality by reducing inflammation and supporting melatonin regulation.",
    "Probiotics": "Probiotics support sleep quality by modulating gut-brain axis signaling.",
    "Vitamin D": "Vitamin D supports sleep quality by helping regulate the sleep-wake cycle through melatonin production.",
    "Vitamin E": "Vitamin E supports sleep quality by reducing oxidative stress that disrupts sleep patterns.",
    "Zinc": "Zinc supports sleep quality by regulating melatonin production."
  },
  "bmr": {
    "Ashwagandha": "Ashwagandha supports BMR by lowering cortisol during chronic stress.",
    "Berberine": "Berberine supports BMR by boosting fat oxidation and improving metabolic efficiency.",
    "Calcium": "Calcium supports BMR by enhancing mitochondrial efficiency and energy production.",
    "Inositol": "Inositol supports BMR by improving insulin sensitivity and glucose regulation.",
    "Magnesium": "Magnesium supports BMR by enhancing mitochondrial efficiency.",
    "Omega 3": "Omega 3 supports BMR by enhancing mitochondrial efficiency and overall energy metabolism.",
    "Probiotics": "Probiotics support BMR by enhancing gut microbiota diversity to optimize energy extraction.",
    "Resveratrol": "Resveratrol supports BMR by enhancing energy expenditure.",
    "Rhodiola Rosea": "Rhodiola Rosea supports BMR by enhancing mitochondrial efficiency.",
    "Curcumin": "Curcumin supports BMR by enhancing mitochondrial function.",
    "Vitamin B12": "Vitamin B12 supports BMR by enhancing energy production.",
    "Vitamin B6": "Vitamin B6 supports BMR by enhancing amino acid metabolism.",
    "Vitamin E": "Vitamin E supports BMR by reducing oxidative stress.",
    "Zinc": "Zinc supports BMR by supporting thyroid hormone production and energy metabolism."
  },
  "deep_sleep": {
    "Ashwagandha": "Ashwagandha supports deep sleep by lowering cortisol and promoting relaxation before bed.",
    "Calcium": "Calcium supports deep sleep by regulating neurotransmitter release to stabilize sleep patterns.",
    "Iron": "Iron supports deep sleep by enhancing oxygen transport to the brain.",
    "Magnesium": "Magnesium supports deep sleep by calming the nervous system and promoting pre-sleep relaxation.",
    "Omega 3": "Omega 3 supports deep sleep by reducing inflammation and promoting serotonin production.",
    "Probiotics": "Probiotics support deep sleep by enhancing gut-brain communication and lowering cortisol.",
    "Rhodiola Rosea": "Rhodiola Rosea supports deep sleep by lowering cortisol to reduce stress.",
    "Tongkat Ali": "Tongkat Ali supports deep sleep by reducing cortisol to lower stress.",
    "Vitamin B2": "Vitamin B2 supports deep sleep by supporting serotonin synthesis to regulate sleep cycles.",
    "Vitamin B6": "Vitamin B6 supports deep sleep by increasing serotonin production to regulate sleep cycles.",
    "Vitamin D": "Vitamin D supports deep sleep by regulating melatonin and supporting healthier sleep-wake rhythms.",
    "Vitamin E": "Vitamin E supports deep sleep by reducing oxidative stress to enhance melatonin production.",
    "Zinc": "Zinc supports deep sleep by modulating NMDA receptors to enhance sleep quality."
  },
  "rem_sleep": {
    "Ashwagandha": "Ashwagandha supports REM sleep by lowering cortisol to ease stress before bed.",
    "Calcium": "Calcium supports REM sleep by regulating neurotransmitter release to stabilize sleep patterns.",
    "Magnesium": "Magnesium supports REM sleep by regulating nighttime brain activity and supporting healthy sleep cycles.",
    "Omega 3": "Omega 3 supports REM sleep by modulating neurotransmitter function and boosting melatonin production.",
    "Probiotics": "Probiotics support REM sleep by supporting sleep-related neurotransmitter activity and lowering cortisol.",
    "Vitamin B2": "Vitamin B2 supports REM sleep by enhancing mitochondrial energy production in brain cells.",
    "Vitamin B6": "Vitamin B6 supports REM sleep by helping regulate sleep cycle signaling through serotonin synthesis.",
    "Vitamin D": "Vitamin D supports REM sleep by supporting melatonin regulation and normal sleep-wake rhythms.",
    "Vitamin E": "Vitamin E supports REM sleep by reducing oxidative stress in the brain.",
    "Zinc": "Zinc supports REM sleep by modulating neurotransmitter activity to enhance sleep quality."
  },
  "sleep_latency": {
    "Ashwagandha": "Ashwagandha helps shorten sleep latency by lowering cortisol for a calmer pre-sleep state.",
    "L-Theanine": "L-Theanine helps shorten sleep latency by calming the nervous system for a smoother wind down.",
    "Magnesium": "Magnesium helps shorten sleep latency by supporting pre-sleep relaxation and melatonin regulation.",
    "Probiotics": "Probiotics help shorten sleep latency by supporting gut-brain signaling and regulating nighttime stress.",
    "Vitamin D": "Vitamin D helps shorten sleep latency by regulating melatonin to ease sleep onset.",
    "Vitamin E": "Vitamin E helps shorten sleep latency by decreasing oxidative stress that disrupts sleep regulation.",
    "Zinc": "Zinc helps shorten sleep latency by supporting melatonin production and sleep signaling."
  },
  "sleep_disruptions": {
    "Ashwagandha": "Ashwagandha helps reduce sleep disruptions by lowering cortisol and easing stress.",
    "Calcium": "Calcium helps reduce sleep disruptions by regulating melatonin production.",
    "Iron": "Iron helps reduce sleep disruptions by restoring adequate oxygen transport to tissues.",
    "L-Theanine": "L-Theanine helps reduce sleep disruptions by promoting relaxation and easing mental tension before sleep.",
    "Magnesium": "Magnesium helps reduce sleep disruptions by promoting muscle relaxation and maintaining healthy melatonin levels.",
    "Omega 3": "Omega 3 helps reduce sleep disruptions by supporting melatonin production and lowering inflammation.",
    "Probiotics": "Probiotics help reduce sleep disruptions by modulating gut-brain axis signaling.",
    "Vitamin B2": "Vitamin B2 helps reduce sleep disruptions by supporting melatonin synthesis.",
    "Vitamin B6": "Vitamin B6 helps reduce sleep disruptions by enhancing serotonin synthesis.",
    "Vitamin D": "Vitamin D helps reduce sleep disruptions by regulating melatonin and supporting sleep-wake balance.",
    "Zinc": "Zinc helps reduce sleep disruptions by modulating melatonin, the sleep-regulating hormone."
  },
  "healthspan": {
    "Acetyl L-Carnitine": "Acetyl L-Carnitine supports healthspan by fueling cellular energy production and helping maintain cognitive function.",
    "Ashwagandha": "Ashwagandha supports healthspan by reducing oxidative stress and inflammation.",
    "CoQ10": "CoQ10 supports healthspan by increasing cellular energy production through mitochondrial support.",
    "Magnesium": "Magnesium supports healthspan by reducing oxidative stress and inflammation.",
    "Omega 3": "Omega 3 supports healthspan by reducing systemic inflammation.",
    "Probiotics": "Probiotics support healthspan by strengthening gut health, supporting immune function, and maintaining metabolic balance.",
    "Resveratrol": "Resveratrol supports healthspan by activating sirtuins to promote cellular repair and longevity.",
    "Vitamin B12": "Vitamin B12 supports healthspan by supporting DNA synthesis and red blood cell formation.",
    "Vitamin D": "Vitamin D supports healthspan by regulating calcium and phosphate balance for strong bone health."
  },
  "pace": {
    "Ashwagandha": "Ashwagandha supports a stronger pace by lowering cortisol to make more energy available.",
    "Iron": "Iron supports a stronger pace by restoring iron status and boosting oxygen delivery through higher hemoglobin.",
    "Probiotics": "Probiotics support a stronger pace by reducing gut inflammation and enhancing nutrient absorption.",
    "Resveratrol": "Resveratrol supports a stronger pace by enhancing mitochondrial efficiency and muscle function.",
    "Rhodiola Rosea": "Rhodiola Rosea supports a stronger pace by reducing perceived exertion through a calmer stress response.",
    "Vitamin B12": "Vitamin B12 supports a stronger pace by enhancing red blood cell production for better oxygen delivery.",
    "Vitamin B2": "Vitamin B2 supports a stronger pace by enhancing mitochondrial energy production.",
    "Vitamin B6": "Vitamin B6 supports a stronger pace by enhancing neurotransmitter synthesis for better muscle coordination."
  },
  "body_composition": {
    "Ashwagandha": "Ashwagandha supports body composition by helping limit fat storage and reduce muscle breakdown.",
    "Berberine": "Berberine supports body composition by aiding fat metabolism and regulating blood sugar and appetite.",
    "Calcium": "Calcium supports body composition by enhancing fat oxidation and bone mineral density to preserve lean mass.",
    "Inositol": "Inositol supports body composition by enhancing insulin sensitivity and helping regulate blood sugar and hormones.",
    "Probiotics": "Probiotics support body composition by optimizing nutrient absorption and balancing gut microbiota to reduce fat storage.",
    "Rhodiola Rosea": "Rhodiola Rosea supports body composition by reducing cortisol levels.",
    "Curcumin": "Curcumin supports body composition by reducing inflammation and oxidative stress.",
    "Vitamin B6": "Vitamin B6 supports body composition by enhancing protein metabolism.",
    "Vitamin C": "Vitamin C supports body composition by supporting muscle mass maintenance and helping preserve strength.",
    "Vitamin D": "Vitamin D supports body composition by enhancing calcium absorption to support muscle function.",
    "Zinc": "Zinc supports body composition by enhancing insulin sensitivity to regulate fat storage."
  }
}

window.whyWeRecommendIt = whyWeRecommendIt;


const allSupplements = [
  "Acetyl L-Carnitine",
  "Alpha GPC",
  //"Apigenin",
  "Ashwagandha",
  "Berberine",
  //"Biotin",
  "Calcium",
  "CoQ10",
  "Curcumin",
  "Folic Acid",
  //"Ginseng",
  "Inositol",
  "Iron",
  "L-Theanine",
  "L-Tyrosine",
  "Magnesium",
  "Omega 3",
  "Probiotics",
  "Resveratrol",
  "Rhodiola Rosea",
  "Tongkat Ali",
  "Vitamin B12",
  "Vitamin B2",
  "Vitamin B6",
  "Vitamin C",
  "Vitamin D",
  "Vitamin E",
  "Zinc"
];

window.allSupplements = allSupplements;